import StepLargeSolarFacilityData from './StepLargeSolarFacilityData';

export default StepLargeSolarFacilityData;
